import loadable from '@loadable/component';
import { SectionWrapper } from '../../styled';
import {
  LegacyAnchor,
  VALUATION_PE_RATIO,
  VALUATION_PB_RATIO,
} from '@/constants/anchors';
import PageAnchor from '@/components/PageAnchor';

const Valuation = loadable(
  () => import('@/pages/CompanyReport/components/Valuation')
);

const ValuationSection = () => {
  return (
    <>
      <SectionWrapper data-cy-id="report-section">
        <PageAnchor id={LegacyAnchor.VALUE} />
        <PageAnchor id={VALUATION_PE_RATIO} />
        <PageAnchor id={VALUATION_PB_RATIO} />
        <Valuation sectionNumber={1} />
      </SectionWrapper>
    </>
  );
};
export default ValuationSection;
